export const cards = [
  {
    id: 1,
    key: "terminal_1",
    images: [
      "/assets/images/terminals/terminal_1.png",
      "/assets/images/terminals/1.1.png",
      "/assets/images/terminals/1.2.png",
      "/assets/images/terminals/1.3.png",
      "/assets/images/terminals/1.4.png",
      "/assets/images/terminals/1.5.png",
      "/assets/images/terminals/1.6.png",
    ],
  },
  {
    id: 2,
    key: "terminal_2",
    images: [
      "/assets/images/terminals/2.png",
      "/assets/images/terminals/2.1.png",
      "/assets/images/terminals/2.2.png",
      "/assets/images/terminals/2.3.png",
      "/assets/images/terminals/2.4.png",
      "/assets/images/terminals/2.5.png",
    ],
  },
  {
    id: 3,
    key: "terminal_3",
    images: [
      "/assets/images/terminals/3.png",
      "/assets/images/terminals/3.1.png",
    ],
  },
  {
    id: 4,
    key: "terminal_4",
    images: [
      "/assets/images/terminals/4.png",
      "/assets/images/terminals/4.1.png",
      "/assets/images/terminals/4.2.png",
      "/assets/images/terminals/4.3.png",
    ],
  },
  {
    id: 5,
    key: "terminal_5",
    images: [
      "/assets/images/terminals/5.png",
      "/assets/images/terminals/5.1.png",
      "/assets/images/terminals/5.2.png",
      "/assets/images/terminals/5.3.png",
    ],
  },
  // {
  //   id: 6,
  //   key: "terminal_6",
  //   images: [
  //     "/assets/images/terminals/6.png",
  //     "/assets/images/terminals/6.1.png",
  //   ],
  // },
  {
    id: 7,
    key: "terminal_7",
    images: [
      "/assets/images/terminals/7.png",
      "/assets/images/terminals/7.2.png",
      "/assets/images/terminals/7.3.png",
      "/assets/images/terminals/7.4.png",
      "/assets/images/terminals/7.5.png",
    ],
  },
  {
    id: 8,
    key: "terminal_8",
    images: [
      "/assets/images/terminals/8.png",
      "/assets/images/terminals/8.1.png",
      "/assets/images/terminals/8.2.png",
    ],
  },
  {
    id: 9,
    key: "terminal_9",
    images: ["/assets/images/terminals/9.png"],
  },
];

